import { deviceType } from "@tm/isomorphic-utils";
import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export const Wrapper = styled.div<{ $bgBanner?: string }>`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border-radius: 16px;
  box-sizing: border-box;
  background: ${({ $bgBanner }) =>
    $bgBanner
      ? `url(${$bgBanner}) center / 100% 100% no-repeat`
      : theme.whiteText};

  @media ${deviceType.mobile} {
    height: auto;
    min-height: 48px;
    padding: 12px 16px;
  }
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  object-fit: contain;
`;

export const TextContent = styled.span`
  flex: 1;
  min-width: 0;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.regular};
  background: linear-gradient(
    181deg,
    rgb(48, 35, 174) 0%,
    rgb(200, 109, 215) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${deviceType.mobile} {
    white-space: normal;
  }
`;

export const SwitchTrack = styled.button<{ $enabled: boolean }>`
  width: 36px;
  height: 22.154px;
  border-radius: 35px;
  border: 1.385px solid
    ${({ $enabled }) => ($enabled ? theme.blueText : theme.whiteText)};
  background: ${({ $enabled }) =>
    $enabled ? theme.blueText : theme.lightBlueBg};
  padding: 0;
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
`;

export const SwitchThumb = styled.span<{ $enabled: boolean }>`
  position: absolute;
  top: 12.5%;
  bottom: 12.5%;
  width: 16.6px;
  border-radius: 100px;
  background: ${({ $enabled }) =>
    $enabled ? theme.whiteText : theme.lightBlack};
  left: ${({ $enabled }) =>
    $enabled ? "calc(100% - 16.6px - 7.69%)" : "7.69%"};
  transition: left 0.2s ease;
`;
